export * from "-!../node_modules/babel-loader/lib/index.js!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=7ba5bd90&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=7ba5bd90&
// module id = 84
// module chunks = 12